/**
 * Card Service
 * Homepage cards management and configuration API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CardTypeResponseDto { 
    /**
     * Card type identifier
     */
    id: string;
    /**
     * Collection identifier
     */
    collectionId: string;
    /**
     * Unique slug for the card type
     */
    slug: string;
    /**
     * Display name of the card type
     */
    display: string;
    /**
     * Description of the card type
     */
    description?: string;
    /**
     * Status of the card type
     */
    status: CardTypeResponseDto.StatusEnum;
    /**
     * Metadata for the card type
     */
    metadata?: any;
    /**
     * Record schema for the card type
     */
    recordSchema?: any;
    /**
     * Form identifier associated with the card type
     */
    formId?: string;
}
export namespace CardTypeResponseDto {
    export type StatusEnum = 'draft' | 'active' | 'inactive';
    export const StatusEnum = {
        Draft: 'draft' as StatusEnum,
        Active: 'active' as StatusEnum,
        Inactive: 'inactive' as StatusEnum
    };
}


